// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import { type Devis, type DevisRequestModel } from './devisModels';

export const devisApi = createApi({
  reducerPath: 'devisApi',
  baseQuery: baseQuery('devis'),
  endpoints: (builder) => {
    return {
      getDevisCount: builder.query<number, DevisRequestModel>({
        query: ({ lang, societe_uuid, univers_uuid }) => {
          return {
            url: `count/${societe_uuid}`,
            method: 'get',
            params: {
              lang,
              univers_uuid,
            },
          };
        },
      }),
      getDevisBySociete: builder.query<Devis[], DevisRequestModel>({
        query: ({ lang, societe_uuid, univers_uuid, archive }) => {
          return {
            url: `societe/${societe_uuid}`,
            method: 'get',
            params: {
              lang,
              univers_uuid,
              archive,
            },
          };
        },
      }),
      storeDevis: builder.mutation<any, any>({
        query: ({ data }) => {
          return {
            url: '',
            method: 'post',
            body: data,
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDevisCountQuery, useStoreDevisMutation, useGetDevisBySocieteQuery } = devisApi;
